import { useEffect } from "react"

const useIntersection = (ref, action, options?) => {
  useEffect(() => {
    if (!window.IntersectionObserver) {
      return
    }
    var observer = new IntersectionObserver(action, options)
    observer.observe(ref.current)
    return () => {
      observer.unobserve(ref.current)
    }
  })
}

export default useIntersection
